var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectDropDown',{attrs:{"id":_vm.id,"name":_vm.name,"label":_vm.label,"options":_vm.professions,"defaultSelected":_vm.defaultSelected ? {id: _vm.defaultSelected.iso} : _vm.professions[0]},on:{"selection-change":_vm.countrySelected}})}
var staticRenderFns = []

export { render, staticRenderFns }